import { defineMessages } from 'react-intl';

const messages = defineMessages({
  // Drawer
  drawerTitle: {
    description: 'Title for the customer details drawer',
    defaultMessage: 'Customer Information',
    id: 'mK7iV7',
  },
  createLabel: {
    description: 'Button text to create a shipping label',
    defaultMessage: 'Create Label',
    id: 'NZH+C4',
  },
  closeDrawer: {
    description: 'Aria label for close drawer button',
    defaultMessage: 'Close drawer',
    id: 'cVLRfv',
  },

  // Customer Information
  editCustomer: {
    description: 'Edit customer button text',
    defaultMessage: 'Edit',
    id: '6woYCg',
  },
  nameLabel: {
    description: 'customerInformation.name',
    defaultMessage: 'Name',
    id: 'blBtCA',
  },
  companyLabel: {
    description: 'customerInformation.company',
    defaultMessage: 'Company',
    id: '4TSHER',
  },
  addressLabel: {
    description: 'customerInformation.address',
    defaultMessage: 'Address',
    id: 'F273tE',
  },
  cityStateZipLabel: {
    description: 'customerInformation.cityStateZip',
    defaultMessage: 'City, State, Zip',
    id: 'YoA1IH',
  },
  countryLabel: {
    description: 'customerInformation.country',
    defaultMessage: 'Country',
    id: 'S35tQ8',
  },
  emailLabel: {
    description: 'customerInformation.email',
    defaultMessage: 'Email',
    id: '5+5Tg3',
  },
  customerTagsLabel: {
    description: 'customerInformation.customerTags',
    defaultMessage: 'Customer Tags',
    id: 'bb/570',
  },
  addTags: {
    description: 'addTags',
    defaultMessage: 'Add tags...',
    id: 'joks11',
  },
  marketplaceUsernamesLabel: {
    description: 'customerInformation.marketplaceUsernames',
    defaultMessage: 'Marketplace Usernames',
    id: 'W5xNz4',
  },
  seeAllMarketplaceUsernames: {
    description: 'customerDetailsModal.allMarketPlaceTitle',
    defaultMessage: 'See all Marketplace Usernames',
    id: 'GB2oOC',
  },

  // Marketplace Usernames Modal
  marketplaceUsernamesTitle: {
    description: 'marketplaceUsernames.title',
    defaultMessage: 'Marketplace Usernames',
    id: 'CwywO8',
  },
  closeButton: {
    description: 'marketplaceUsernames.close',
    defaultMessage: 'Close',
    id: 'mhzdeJ',
  },

  // Previous Orders
  totalCount: {
    description: 'customerPreviousOrders.totalCount',
    defaultMessage: 'Total Orders: {totalCount}',
    id: 'TE+FzK',
  },
  noPreviousOrders: {
    description: 'customerPreviousOrders.noOrders',
    defaultMessage: 'There are currently no orders',
    id: 'ca9Aki',
  },
  orderPermissionRequired: {
    description: 'Message displayed when user lacks permission to view customer orders',
    defaultMessage: 'Order Management permission is required to view orders.',
    id: '15c8og',
  },
});

export default messages;
